import { render, staticRenderFns } from "./TimeFrameSummary.vue?vue&type=template&id=1c2b57ab&scoped=true&"
import script from "./TimeFrameSummary.vue?vue&type=script&lang=js&"
export * from "./TimeFrameSummary.vue?vue&type=script&lang=js&"
import style0 from "./TimeFrameSummary.vue?vue&type=style&index=0&id=1c2b57ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b57ab",
  null
  
)

export default component.exports